module.exports = __webpack_public_path__ + "img/head-surveillance.33848bc6.png";